import React from "react";
import { Box } from "@mui/material";
import CommonButton from "../../../CommonComponents/CommonButton";
import styles from "../AddVendorModal.module.css";
import { addLocationBtnSx } from "../AddVendorModal.styles";

const AddLocationBar = ({ onAddLocation }) => (
  <Box className={styles.addLocationBar}>
    <CommonButton
      label="+ Add Location"
      isColor
      onClick={onAddLocation}
      removeBorder
      isHover
      hoverColor="#EBEEF8"
      textColor="#5E6366"
      backgroundColor="#EBEEF8"
      fitContent
      sx={addLocationBtnSx}
    />
  </Box>
);

export default AddLocationBar;
